import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import loginReducer from './reducers/loginReducer';
import customTypeReducer from './reducers/customTypeReducer';
import projectReducer from './reducers/projectReducer';
import contentReducer from './reducers/contentReducer';
import fileReducer from './reducers/fileReducer';
import imageReducer from './reducers/imageReducer';
import cartReducer from './reducers/cartReducer';
import domainReducer from './reducers/domainReducer';
import languagesReducer from './reducers/languagesReducer';
import translateReducer from './reducers/translateReducer';
import customersReducer from './reducers/customersReducer';
import userReducer from './reducers/userReducer';
import providerReducer from './reducers/providerReducer';
import myCoinsReducer from './reducers/myCoins';
import itemReducer from './reducers/itemReducer';
import pushNotificationReducer from './reducers/pushNotificationReducer';
import ordersReducer from './reducers/ordersReducer';
import categoriesReducer from './reducers/categoriesReducer';
import claimReducer from './reducers/claimReducer';
import providersReducer from './reducers/providersReducer';
import accountReducer from './reducers/accountReducer';
import emailSubscriptionReducer from './reducers/emailSubscriptionReducer';
import deliveryReducer from './reducers/deliveryReducer';
import emailNotificationReducer from './reducers/emailNotificationReducer';
import textNotificationReducer from './reducers/textNotificationReducer';
import commentsReducer from './reducers/commentsReducer';
import complainsReducer from './reducers/complainsReducer';
import reviewReducer from './reducers/reviewReducer';
import emailActivationReducer from './reducers/emailActivationReducer';
import paymentSubscriptionReducer from './reducers/paymentSubscriptionReducer';
import iPayReducer from './reducers/iPayReducer';
import payzeProviderReducer from './reducers/payzeProviderReducer';
import contentReviewReducer from './reducers/contentReviewReducer';

const reducer = combineReducers({
  account: accountReducer,
  cart: cartReducer,
  categories: categoriesReducer,
  claims: claimReducer,
  comment: commentsReducer,
  complains: complainsReducer,
  content: contentReducer,
  contentReview: contentReviewReducer,
  customType: customTypeReducer,
  customer: customersReducer,
  delivery: deliveryReducer,
  domain: domainReducer,
  emailActivation: emailActivationReducer,
  emailNotification: emailNotificationReducer,
  file: fileReducer,
  iPay: iPayReducer,
  images: imageReducer,
  item: itemReducer,
  language: languagesReducer,
  login: loginReducer,
  myCoins: myCoinsReducer,
  order: ordersReducer,
  paymentSubscription: paymentSubscriptionReducer,
  payzeProvider: payzeProviderReducer,
  project: projectReducer,
  provider: providerReducer,
  providers: providersReducer,
  pushNotifications: pushNotificationReducer,
  review: reviewReducer,
  subscription: emailSubscriptionReducer,
  textNotification: textNotificationReducer,
  translate: translateReducer,
  users: userReducer
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_SUCCESS') {
    state = undefined;
  }
  return reducer(state, action);
};

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
